export default __webpack_public_path__ + "static/media/webinar.21d90a76.jpg";